"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RubricCriteria = exports.RubricRating = exports.QuestionRubric = exports.QuestionRubricResponses = exports.LrnQuestionRubricResponses = exports.LrnQuestionRubricResponse = void 0;
/**
 * @property {string} apiVersion    - version for Learnosity Author API
 * @property {number} revision      - rubric revision
 * @property {string} type          - rubric type
 * @property {string} value         - rubric's value
 */
var LrnQuestionRubricResponse = /** @class */ (function () {
    function LrnQuestionRubricResponse(rubricResponse) {
        Object.assign(this, rubricResponse);
    }
    return LrnQuestionRubricResponse;
}());
exports.LrnQuestionRubricResponse = LrnQuestionRubricResponse;
/**
 * @property {string} key                                      - rubric response key
 * @property {LrnQuestionRubricResponse} questionRubricResponse   - rubric response
 */
var LrnQuestionRubricResponses = /** @class */ (function () {
    function LrnQuestionRubricResponses(rubricResponses) {
        Object.assign(this, rubricResponses);
    }
    return LrnQuestionRubricResponses;
}());
exports.LrnQuestionRubricResponses = LrnQuestionRubricResponses;
/**
 * @property {string} key     - rubric response key
 * @property {number} value   - rubric response value
 */
var QuestionRubricResponses = /** @class */ (function () {
    function QuestionRubricResponses(rubricResponses) {
        Object.assign(this, rubricResponses);
    }
    return QuestionRubricResponses;
}());
exports.QuestionRubricResponses = QuestionRubricResponses;
/**
 * @property {string} id                      - attempt rubric identifier
 * @property {string} attemptId               - attempt identifier
 * @property {string} externalItemId          - item identifier
 * @property {string} externalQuestionId      - question identifier
 * @property {any}    responses               - Learnosity response format
 */
var QuestionRubric = /** @class */ (function () {
    function QuestionRubric(attemptRubric) {
        Object.assign(this, attemptRubric);
    }
    return QuestionRubric;
}());
exports.QuestionRubric = QuestionRubric;
var RubricRating = /** @class */ (function () {
    function RubricRating(rubricRating) {
        Object.assign(this, rubricRating);
    }
    return RubricRating;
}());
exports.RubricRating = RubricRating;
var RubricCriteria = /** @class */ (function () {
    function RubricCriteria(rubricCriteria) {
        Object.assign(this, rubricCriteria);
    }
    return RubricCriteria;
}());
exports.RubricCriteria = RubricCriteria;
